import { create } from 'zustand';
import { LockDetails } from '@app/hooks/plugins/useKpNftLockDetails';
import { Vault } from '@app/hooks/plugins/useVaults';
import { PairToken } from '@app/types/pool';
import { Token } from '@app/types/token';
import { persist } from 'zustand/middleware';
import { formatUnits } from 'ethers/lib/utils';
import { BigNumber } from 'ethers';
import { isDateRangeExpired } from '@app/helpers/formatDate';
import { NFTMarketplaceListing } from '@app/types/nftMarketplace';
import { useConfig } from '@app/config';

export type NFTCartItem = {
  listingId: string;
};

type NftCartState = {
  cartItems: NFTCartItem[];
  add: (nft: NFTCartItem) => void;
  remove: (id: string) => void;
  clearCart: () => void;
  totalItems: () => number;
  getListingIds: () => string[];
  isInTheCart: (listingId: string) => boolean;
};

export const useCartStore = create(
  persist<NftCartState>(
    (
      set: (
        partial:
          | Partial<NftCartState>
          | ((state: NftCartState) => Partial<NftCartState>)
      ) => void,
      get: () => NftCartState
    ) => ({
      cartItems: [],
      add: (newItem: NFTCartItem) => {
        set(state => ({
          ...state,
          cartItems: state.cartItems.some(
            item => item.listingId === newItem.listingId
          )
            ? state.cartItems
            : [...state.cartItems, newItem]
        }));
      },
      remove: (id: string) => {
        set(state => ({
          ...state,
          cartItems: state.cartItems.filter(item => item.listingId !== id)
        }));
      },
      clearCart: () => {
        set(() => ({ cartItems: [] }));
      },
      totalItems: () => get().cartItems.length,
      getListingIds: () => get().cartItems.map(item => item.listingId),
      isInTheCart: (listingId: string) =>
        get().cartItems.some(item => item.listingId === listingId)
    }),
    {
      name: 'nft-marketplace-cart-storage'
    }
  )
);
